export const ERROR_TYPE = {
  PAY_TYPE_LIST_EMPTY: 'PAY_TYPE_LIST_EMPTY', // 购物车定价表缺少
  PRODUCT_LIST_EMPTY: 'PRODUCT_LIST_EMPTY', // 商品列表返回为空没有返回
  AUTO_MATCH_PRODUCT_FAIL: 'AUTO_MATCH_PRODUCT_FAIL', // 游戏内打开没有自动匹配上商品
  MATCH_CART_PRODUCT_LEVEL_FAIL: 'MATCH_CART_PRODUCT_LEVEL_FAIL', // 购物车商品价格档位不匹配
  PAGE_JUMP_404: 'PAGE_JUMP_404' // 404页面
};

export const errorReport = (errorType, extraInfo = {}) => {
  try {
    const gameId =
      new URL(window.location.href).searchParams.get('gameId') || '';
    console.error(
      `customer_error_pay:${errorType}.${JSON.stringify(extraInfo)}.${gameId}`
    );
  } catch (e) {
    console.error(e);
  }
};

export const errorReport404 = () => {
  const searchParams = new URL(window.location.href)?.searchParams || {};
  let version = 'v0';
  if (window.isOfficialStore) {
    version = 'v1';
  } else if (window.isOfficialWebStore) {
    version = 'v2';
  } else if (window.isOfficialTopup) {
    version = 'v3';
  } else if (window.isOfficialTopupNew) {
    version = 'v3.5';
  }
  errorReport(ERROR_TYPE.PAGE_JUMP_404, {
    version: version,
    packageName: searchParams.get('packageName') || '',
    domain: window.location.hostname,
    packageVersion: searchParams.get('packageVersion') || ''
  });
};
